import React, { useEffect, useState } from "react";
import TextField from "@mui/material/TextField";
import InputLabel from "@mui/material/InputLabel";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { addNewInventory, editInventory, fetchInventoryById } from "../../store/slices/thunk";
import { toast, ToastContainer } from "react-toastify";
import "../Maintenance/mainten.scss";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { Button } from "@mui/material";
import Spinner from "react-bootstrap/esm/Spinner";


const Addpartinventory = () => {
  const navigate = useNavigate();

  const [addInventory, setAddInventory] = useState({
    name: "",
    description: "",
    stock: "",
    status: "",
    _id: "",
  });
  
  const { id } = useParams<any>(); 
  const [isEdit, setIsEdit] = useState(false); 
  const [loading, setLoading] = useState(false);
  const dispatch: any = useDispatch();
 useEffect(() => {
    const fetchData = async () => {
      if (id) {
        setIsEdit(true);
        const response: any = await dispatch(fetchInventoryById(id));
        const { name, description, stock, status, _id } = response.data; 

        setAddInventory({
          name,
          description,
          stock,
          status,
          _id,
        });
        console.log(addInventory);
        // navigate(`/editUser/${id}`);
      } else {
        setIsEdit(false);
        setAddInventory({
          name: "",
          description: "",
          stock: "",
          status: "",
          _id: "",
        });
        // navigate("/addUser");
      }
    };
    fetchData();
  }, [id, navigate, dispatch]);

  const handleChange = (e:any) => {
    const { name, value } = e.target;
    setAddInventory((prevData) => ({
      ...prevData,
      [name]: value
    }));
  };
  const navigateToInventoryList = () => {
    navigate("/part-inventory-list");
  };
   const handleSubmit = async (e: any) => {
      e.preventDefault();
      console.log("Sending:", addInventory);
  setLoading(true);
      try {
        
        if (isEdit) {
          if(addInventory.status === '' && addInventory.stock === '' && addInventory.description === '' && addInventory.name === ''){
            toast.error('Fill All Fields')
          } else{
            const res: any = await dispatch(editInventory(addInventory));
          if (res.data && res.isSuccess) {
            console.log("Success:", res);
            toast.success("Part Inventory Edited!");
            navigate("/part-inventory-list");
          }else {
            toast.error("Part Inventory Not Edit!");
          }
          } 
        } else {
          if(addInventory.status === '' && addInventory.stock === '' && addInventory.description === '' && addInventory.name === ''){
            toast.error('Fill All Fields')
          } else{
            const res: any = await dispatch(addNewInventory(addInventory));
            if (res.data && res.isSuccess) {
              console.log("Success:", res);
              toast.success("Part Inventory added!");
              navigate("/part-inventory-list");
            } else {
              toast.error("Part Inventory Not added!");
            }
          }
        }
      } catch (error) {
        console.error("Error:", error);
        toast.error("Something went wrong!");
      } finally {
        setLoading(false);
      }
    };
  return (
    <div>
      <ToastContainer/>
      <div className="boDy">
      <div className="head d-flex justify-content-lg-between justify-content-start flex-column flex-lg-row flex-wrap">
          <div className="d-flex flex-column">
                        <h2 className="fw-bold fs-4" style={{ color: "#1F2937" }}>{isEdit ? "Edit Parts Inventory" : "Add Parts Inventory"}</h2>
            <p style={{ color: "#4B5563" }}>
Fill in the inventory item information below</p>
          </div>
          <button
            type="button"
            onClick={navigateToInventoryList}
            className="btn rounded-2"
            style={{ backgroundColor: "transparent",width:"fit-content" }}
          >
            <KeyboardBackspaceIcon />
          <span style={{marginLeft:"10px"}}>Back To List</span>
          </button>
        </div>
        <div className="boX">
          <div className="container mt-3">
            <div className="row">
              <div className="col-md-12">
                <div className="row">
                  <div className="col-md-6">
                <h6  className="d-block mb-2"
  style={{
    fontSize: "0.875rem",
    fontWeight: 700,
    color: "#374151",
  }}>Name</h6>
                <TextField
                  id="outlined-email"
                  placeholder="Enter name of parts"
                  name="name"
                  type="text"
                  onChange={handleChange}
                  value={addInventory.name}
                  fullWidth
                  sx={{ height: "48px", width: "100%" }}
                  
                  variant="outlined"
                  // sx={{
                  //     '& .MuiInputBase-input': {
                  //       padding: '8px',
                  //   },
                  // }}
                  />
                {" "}
              </div>
              <div className="col-md-6">
                <h6  className="d-block mb-2"
  style={{
    fontSize: "0.875rem",
    fontWeight: 700,
    color: "#374151",
  }}>Stock</h6>
                <TextField
                  name="stock"
                  type="number"
                  id="outlined-email"
                  placeholder="Total stock Availible"
                  value={addInventory.stock}
                  onChange={handleChange}
                  fullWidth
                  sx={{ height: "48px", width: "100%" }}
                  variant="outlined"
                  // sx={{
                  //     '& .MuiInputBase-input': {
                  //       padding: '8px',
                  //   },
                  // }}
                />{" "}
              </div>
              <div className="col-md-12">
                        <div className="gps">
                  <h6   className="d-block mb-2"
  style={{
    fontSize: "0.875rem",
    fontWeight: 700,
    color: "#374151",
  }}>Parts Description</h6>
                  <TextField
                     name="description"
                     type="text"
                     placeholder="part discription"
                     value={addInventory.description}
                     onChange={handleChange}
                    multiline
                    rows={2}
                    fullWidth
                  />
                </div>
              </div>
                     <div className="col-md-6">
                <div>
                <h6  className="d-block mb-2"
  style={{
    fontSize: "0.875rem",
    fontWeight: 700,
    color: "#374151",
  }}>Parts Status</h6>
                <Box sx={{ minWidth: 120 }}>
                  <FormControl fullWidth>
                    <select name="status" value={addInventory.status} onChange={handleChange} className="select">
                    <option value="">-- Select --</option>
                    <option value="active">Active</option>
                    <option value="inActive">InActive</option>
                  </select>
                  </FormControl>
                </Box>
                </div>
                {/* <div className="mt-4 aDD" style={{backgroundColor:"transparent"}}>
                  <Button  onClick={handleSubmit} disabled={loading} style={{ textTransform: "none",fontWeight:"600",width:"auto" }}>
                    {loading ? (
                      <>
                        <Spinner
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                          className="me-2"
                        />
                        {isEdit ? "Edit..." : "Add..."}
                      </>
                    ) : (
                      isEdit ? "Edit Inventory " : "Add Inventory"
                    )}
                  </Button>
                </div> */}
              </div>
                </div>
              </div>
            </div>
          </div>

          {/* <div className="container">
            <div className="row">
              <div className="col-md-3"></div>
              <div className="col-md-6">
                <div className="gps">
                  <h6>Parts Description</h6>
                  <TextField
                     name="description"
                     type="text"
                     placeholder="part discription"
                     value={addInventory.description}
                     onChange={handleChange}
                    multiline
                    rows={2}
                    fullWidth
                  />
                </div>
              </div>
              <div className="col-md-3"></div>
            </div>
          </div> */}
          {/* <div className="container">
            <div className="row">
              <div className="col-md-3"></div>
              <div className="col-md-6">
                <h6>Stock</h6>
                <TextField
                  name="stock"
                  type="number"
                  id="outlined-email"
                  placeholder="Total stock Availible"
                  value={addInventory.stock}
                  onChange={handleChange}
                  fullWidth
                  sx={{ height: "48px", width: "100%" }}
                  variant="outlined"
                  // sx={{
                  //     '& .MuiInputBase-input': {
                  //       padding: '8px',
                  //   },
                  // }}
                />{" "}
              </div>
              <div className="col-md-3"></div>
            </div>
          </div> */}
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                {/* <div>
                <h6>Parts Status</h6>
                <Box sx={{ minWidth: 120 }}>
                  <FormControl fullWidth>
                    <select name="status" value={addInventory.status} onChange={handleChange} className="select">
                    <option value="">-- Select --</option>
                    <option value="active">Active</option>
                    <option value="inActive">InActive</option>
                  </select>
                  </FormControl>
                </Box>
                </div> */}
                <div className="mt-4 aDD" style={{backgroundColor:"transparent"}}>
                  <Button  onClick={handleSubmit} disabled={loading} style={{ textTransform: "none",fontWeight:"600",width:"auto" }}>
                    {loading ? (
                      <>
                        <Spinner
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                          className="me-2"
                        />
                        {isEdit ? "Edit..." : "Add..."}
                      </>
                    ) : (
                      isEdit ? "Edit Inventory " : "Add Inventory"
                    )}
                  </Button>
                </div>
              </div>
            </div>
            </div>
          </div>
        </div>
      </div>
  );
};

export default Addpartinventory;
